import { Chip } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { isValidDate } from '../helpers/dates';
import useActiveSite from '../hooks/useActiveSite';

const NewLabel = ({ featureFlag, style = {} }) => {
  const activeSite = useActiveSite();
  const featureFlagsEntities = useSelector((state) => state.entities.featureFlags);
  const featureFlags = Object.values(featureFlagsEntities.byId);
  const featureFlagId = featureFlags.find((ff) => ff.name === featureFlag)?.id;

  const featureFlagEnabledAt = activeSite?.feature_flags_enabled_at?.[featureFlagId];

  const isOlderThan30Days = isValidDate(featureFlagEnabledAt) ? moment().diff(featureFlagEnabledAt, 'days') > 30 : null;

  // Do not show when the date is older than 30 days
  if (isOlderThan30Days) {
    return null;
  }

  return (
    <Chip
      label="NEW"
      size="small"
      color="primary"
      sx={[{ height: 16, fontSize: 10, fontWeight: 700, marginLeft: 0.5, verticalAlign: 'middle' }, { ...style }]}
    />
  );
};

export default NewLabel;
